// import React from 'react';
import { Navigate } from "react-router-dom";
import { useAuth } from "../../api/auth/AuthProvider";
import { HOME_ROUTE, LOGIN_ROUTE } from "../../routing/app-routes";
import RegistrationComplete from "../pages/email-verification/RegistrationComplete";
import { storePushURL, storeInviteTokenFromURL } from "@/api/auth/session";
import useWorkspaceId from "@/hooks/use-workspace-id/useWorkspaceId";
import composeRoute from "@/api/routes/utils/route-utils/route-utils";
import { useToastStore } from "@/state/toasts/toast-store";
import { TOAST_TYPES } from "../common/toasts/toast-constants";
import { useTranslation } from "react-i18next";
import { hasWorkspace } from "@/utils/workspace-utils/workspace-utils";
const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  const { t } = useTranslation();
  const { workspaceId, routeWorkspaceId } = useWorkspaceId();
  const addToast = useToastStore((state) => state.addToast);

  const checkWorkspaceAccess = (children) => {
    // Since we dont use routeWorkspaceId in the auth resolveWorkspaceId call, if these dont match then the
    // user has navigated to a workspace they dont have access to, either by manually changing the URL or via an old link.
    // In either case we want to redirect them to the home page and show a toast explaining why
    if (
      routeWorkspaceId &&
      !hasWorkspace(auth.user?.Workspaces, routeWorkspaceId)
    ) {
      addToast({
        type: TOAST_TYPES.ERROR,
        message: t("workspaceNotFound"),
        id: "workspace-not-found",
      });
      return <Navigate to={composeRoute(HOME_ROUTE, [workspaceId])} />;
    }
    return children;
  };

  if (auth.token && !auth.abstractRequestId) {
    if (auth.user?.emailVerified) {
      return checkWorkspaceAccess(children);
    } else if (auth) {
      return <RegistrationComplete />;
    }
  }
  storeInviteTokenFromURL();
  storePushURL();
  return <Navigate to={LOGIN_ROUTE} />;
};

export default ProtectedRoute;
